import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import {
  PATH_RESOLVABLE_MISSION_TYPES,
  PATH_RESOLVABLE_MISSION_TYPES_NEW,
} from '../../app/constants/paths.constant';
import { FormVariant } from '../../forms';
import { ResolvableMissionTypeForm } from '../../forms/ResolvableMissionType';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

export const NewResolvableMissionTypePage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.ResolvableMissionTypes);
  }, [setPage]);

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle("Création d'un Type de Mission")}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_RESOLVABLE_MISSION_TYPES,
            label: 'types de missions',
            key: 'resolvableMissionTypes',
          },
          {
            to: PATH_RESOLVABLE_MISSION_TYPES_NEW,
            label: 'nouveau',
            key: 'newResolvableMissionType',
          },
        ]}
      />
      <PageTitle title="Création d'un Type de Mission" />
      <ResolvableMissionTypeForm
        formVariant={FormVariant.Creation}
        showCancelButton={false}
      />
    </>
  );
};
